const ja = {
    "success": "成功",
    "failure": "失敗",
    "project": "プロジェクト",
    "status": "状態",
    "start_at": "開始日",
    "end_at": "終了日",
    "assignees": "担当者",
    "priority": "優先度",
    "progress": "進捗",
    'estimated_time': '見積工数',
    "confirm_password_does_not_match": "確認用のパスワードはパスワードと同じではありません。",
    "password_invalid": "パスワードでスペースを含めることはできません。",
    "confirm": "確定",
    "cancel": "キャンセル",
    "has_error": "エラー!",
    "transfer_work": "タスクの移動",
    "are_you_sure_you_want_to_move_this_task_from_project": "このタスクを移動してもよろしいでしょうか。",
    "to_project": "に",
    "view_detail": "詳細",
    "effort": "効率",
    "score":"点",
    "result":'結果',
    "comment": '備考',
    "name_evaluation":"評価書名",
    "date": "日付",
    "notes_cannot_be_empty": "メモは必須項目です。",
    "confirm_deletion_timekeeping": "この勤怠を削除してもよろしいでしょうか。",
    "time_checkin": "チェックイン時間",
    "time_checkout": "チェックアウト時間",
    "not_check": "チェックしなかった",
    "working_time": "工数",
    "time_in":"In",
    "time_out":"Out ",
    "remaining_leave_hours": "有給休暇時間",
    "delete_timekeeping": "勤怠の削除!",
    "delete_timekeeping_success": "勤怠を削除しました。",
    "start" : "開始",
    "finish" : "終了",
    "start_task" : "タスクを開始する",
    "finish_task" : "タスクを終了する",
    "category": "カテゴリ",
    "item": "小項目",
    "description": "説明",
    "select_members":"メンバーを選択する",
    "error_position":"職位を選択してください。",
    "error_member":"メンバーを選択してください。",
    'january': '１月',
    'february': '２月',
    'march': '３月',
    'april': '４月',
    'may': '５月',
    'june': '６月',
    'july': '７月',
    'august': '８月',
    'september': '９月',
    'october': '１０月',
    'november': '１１月',
    'december': '１２月',

    'Su': '日曜日',
    'Mo': '月曜日',
    'Tu': '火曜日',
    'We': '水曜日',
    'Th': '木曜日',
    'Fr': '金曜日',
    'Sa': '土曜日',

    "jsgantt": {
        'january': '１月',
        'february': '２月',
        'march': '３月',
        'april': '４月',
        'maylong': '５月',
        'june': '６月',
        'july': '７月',
        'august': '８月',
        'september': '９月',
        'october': '１０月',
        'november': '１１月',
        'december': '１２月',

        'jan': '１月',
        'feb': '２月',
        'mar': '３月',
        'apr': '４月',
        'may': '５月',
        'jun': '６月',
        'jul': '７月',
        'aug': '８月',
        'sep': '９月',
        'oct': '１０月',
        'nov': '１１月',
        'dec': '１２月',

        'Sunday': '日曜日',
        'Monday': '月曜日',
        'Tuesday': '火曜日',
        'Wednesday': '水曜日',
        'Thursday': '木曜日',
        'Friday': '金曜日',
        'Saturday': '土曜日',

        'Sun': '日曜日',
        'Mon': '月曜日',
        'Tue': '火曜日',
        'Wed': '水曜日',
        'Thu': '木曜日',
        'Fri': '金曜日',
        'Sat': '土曜日',

        'resource': '担当者',
        'duration': '期限',
        'comp': '進捗 (%)',
        'completion': '進捗',
        'startdate': '開始日',
        'enddate': '終了日',
        'moreinfo': 'もっと情報',
        'notes': 'メモ',
        'format': '体制',

        'hour': '時間',
        'day': '日間',
        'week': '週間',
        'month': 'ヵ月',
        'quarter': '四半期間',

        'hours': '時間',
        'days': '日間',
        'weeks': '週間',
        'months': 'ヵ月',
        'quarters': '四半期間',

        'hr': '時間',
        'dy': '日間',
        'wk': '週間',
        'mth': 'ヵ月',
        'qtr': '四半期間 ',

        'hrs': '時間',
        'dys': '日間',
        'wks': '週間',
        'mths': 'ヵ月',
        'qtrs': '四半期間',

        'tooltipTemplate': 'アップロード中',
    },
    //Calendar
    'Th 2' : '月曜日',
    'Th 3' : '火曜日',
    'Th 4' : '水曜日',
    'Th 5' : '木曜日',
    'Th 6' : '金曜日',
    'Th 7' : '土曜日',
    'location' : '位置',
    'create_event' : '打ち合わせを作成する',
    'edit_event' : '打ち合わせを編集する',
    'detail_event' : '打ち合わせの詳細',
    'save' : '保存',
    'return' : '戻る',
    'delete' : '削除',
    'delete_event' : '打ち合わせを削除する',
    'edit' : '編集',
    'created_by' : ' 作成者',

    // Timekeeping management
    "file_content_invalid" : "ファイルは内容のフォーマットが正しくありません。",
    "require_timekeeping_file_format" : ".csv または .txtのフォーマットであるファイルを添付してください。",

    // Evaluation Result
    "subsection" : "小項目",
    "evaluators" : "評価者",
    'required': ' は必須項目です。',
    'max_255': ' 255文字以下で入力してください。',
    "unique" : ' 既に存在しています',
    "confirm_redirect": "この変更は保存しますか?",
    "yes":"はい",
    "no": "いいえ",
    "confirm_exit": '変更された内容が保存されない恐れがあります。完了せずに移動しますか。',
    'evaluatee_placeholder': '評価される人を選択',
    'evaluator_placeholder': '評価する人を選択',
    // Evaluation template
    'evaluatee_placeholder': '評価される人を選択',
    'evaluator_placeholder': '評価する人を選択',
    "confirm_copy_evaluation": 'この評価をコピーします。よろしいでしょうか？',
    "confirm_copy_template": 'この評価テンプレートをコピーしてもよろしいでしょうか？',
    'position_edit_succeed' : '職位を成功に更新しました。',
    'resource_edit_succeed' : 'リソースを成功に編集しました。',
    "confirm_copy_evaluation": 'この評価をコピーします。よろしいでしょうか？',
    // Order
    'delete_order' : 'オーダーを削除します。',
    'confirm_deletion_order' : 'よろしいですか？',
    'required_comment' : '備考を入力してください。',
    'select_required': ':attribute を選択してください！',
    'Please_choose_a_dish' : '食べ物を選択してください。',
    'Please_enter_the_dish' : '食べ物の名前を入力してください。',
    'Please_enter_employee_name':'社員の名前を入力してください。',
    'please_enter_option': '選択肢を入力してください!',
    'employee_exist':'この社員の注文が完了しました。',
    'Please_choose_month' : '月を入力してください!',
    'Date_format_error' : 'MM/YYYYで月を入力してください!',
    'Error_maxlength_option':'選択肢は1000桁で入力してください!',
    // Validate form create, edit task
    'please_enter_estimated_time' : '見積時間を入力してください!',
    'please_enter_title_task' : 'タスクの見出しを入力してください!',
    'please_enter_project' : '案件を選択してください!',
    'please_enter_type' : 'タイプを選択してください!',
    'please_enter_status' : 'ステータスを選択してください!',
    'please_enter_priority' : '優先度を選択してください!',
    // Request
    'please_enter_bta' : 'Vui lòng nhập BTA',
    'Error_max_bta' : 'Vui lòng nhập dưới 900.000.000',
    'before_or_equal' : ':attribute は :date 以前で入力してください!',
    'after_or_equal' : ':attribute は:date以降入力してください!',

    'vacation': '休暇',

    'max_name_property_type': '',
    // Task of the day
    'task': 'タスク',
    'please_enter_name_property_management' : '',
    'max_name_property_management': '',
    //property type
    "please_enter_name": ":attribute を入力してください!",
    "max_length": ":attributeは:max桁で入力してください!",
    "property_type_name": "資産類名",
    "property_type_code": "資産コードヘッダー",
    'property_status_name': '資産状態名',
    "department": "部署",
    "department_code": "部署コード",
    "property_agency_name": "単位名",
    "not_in": ':attributeは存在していません!',
    'asset_name': '資産名',
    'name_in_contract': '資産名（契約より）',
    "name_short": "資産略名",
    "management_unit_id": "資産管理単位",
    "type_id": "資産類",
    "department_id" : "利用単位",
    "user_use_asset": "ユーザー",
    'asset_code': '資産コード',
    "handover_record_code": "引継記録書番号",
    "seri_number": "シリアルナンバー",
    "supplier": "提供者",
    "manufacturer": "メーカー",
    "manufacturing_date": "製造日",
    "asset_category": "カテゴリー",
    "usage_date": "利用日",
    "purchase_date": "購入日",
    "condition_id": "状態",
    "source_of_origin": "形成元",
    "asset_location": "位置",
    "asset_description": "説明",
    "residual_value" : "残価",
    "original_price" : "原価",
    "premises": "ブランチ",
    "country_of_manufacture": "製造国",
    'max_file' : ':attributeは :max MB以下でアップロードしてください!',
    'mimes_file' : ':attributeは:values!のフォーマットで選択してください!',
    "asset_image" : "画像",
    "asset_file": "添付ファイル",
    "asset_note": "備考",
    "asset_branch": "施設",
    "asset_resource": "形成元",
    "asset_bidding_package_name": "パッケージ名",
    "asset_bidding_package_code": "パッケージコード",
    "add_task": "タスクを登録する",
    "enter_task_name": "タスクのタイトルを入力する",
    "close" : "閉じる",
    //Customer
    "customer_name": "顧客名",
    "evaluation_template": "評価のテンプレート",
    "evaluator": "評価者",
    "evaluatee": "被評価者",
    "evaluation_finalizer": "評価承認者",
    "evaluation_form_name": "評価書名",
    "considering_the_time_period": "評価用期間",
    "evaluation_deadline": "評価提出期限",
    "apply_for": "被評価者",
    "evaluation_type": "評価種別",
    "evaluatee_duplicate": "評価される人は重複してはいけません。",
    "evaluator_duplicate": "評価する人は重複してはいけません。",
    "invalid_date_range": "有効な日付を入力してください。",
    "evaluation_deadline_after_considering_the_time_period": "評価期限は評価期間以降で入力してください！",
    "deadline_must_be_after_evaluation_time": "評価期間中は、評価提出開始日を再選択することはできません。",
    "add": "追加",
    "remove": "削除",
    "actual_time": "実際の工数",
    'min_numeric': ':attribute は :min 以上で入力してください!',
    //work schedule collaborator
    "max_shifts": "勤務シフトは最大5件までです",

    //Vacation validation messages
    "vacation_block_two_hours": "休暇時間は2時間単位である必要があります。",
    "vacation_working_hours": "休暇時間は勤務時間内である必要があります。",
    "vacation_time_order": "休暇時間は0以外である必要があります。",
    // Checklist
    "performer": "出演者",
};
export default ja;



// WEBPACK FOOTER //
// ./resources/build/js/locales/ja.js